<template>
  <div :class="{'story-container': !isMenuMiniSize, 'story-container-thin-menu': isMenuMiniSize}">
    <StoryList v-if="$route.path === '/dashboard/story' || $route.path === '/client/story'" :PCTRLLOG="CTRLLOG"/>
    <StoryEdit v-if="$route.path.indexOf('/dashboard/story/edit') >= 0 || $route.path.indexOf('/client/story/edit') >= 0"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StoryList    from '@/views/DashBoard/Story/StoryList'
import StoryEdit    from '@/views/DashBoard/Story/StoryEdit'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'Story',
  componentName: 'Story',
  components: {
    StoryList,
    StoryEdit
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState("setting",["isMenuMiniSize"]),
  },
  data () {
    return {
      COMPONENT_NAME: 'Story',
    }
  },
}
</script>

<style lang="scss" scoped>
.story-container {
  height: 100vh;
  width: calc(100% - 205px);
}
.story-container-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Story/Story.vue